<script setup>
import { useSessionStore } from '@stores';
import { nameFormat, timeFormat } from '@utils';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });
const sessionStore = useSessionStore();

const { progressList, blockedList, finishedList } = storeToRefs(sessionStore);
</script>

<template>
    <aside class="aside">
        <Card class="counters-card" v-if="progressList?.length">
            <template #title>
                <Htag class="title text-[#8A8CD9]">
                    <div class="flex items-center gap-2">
                        <span class="progress"></span>
                        {{ t('global.process') }}
                    </div>

                    <router-link class="see-all" :to="`/session/${sessionStore.selectedSession}?status=IN_PROGRESS`">{{ t('global.seeAll') }} <i class="ml-2 pi pi-arrow-right"></i></router-link>
                </Htag>
            </template>
            <template #content>
                <AvatarLine :name="nameFormat(full_name)" :time="timeFormat(started_at)" :src="photo" :key="id" class="avatar" :to="`/session/${session_id}/user/${id}`" v-for="{ full_name, photo, id, started_at, session_id } in progressList" />
            </template>
        </Card>
        <Card class="counters-card" v-if="blockedList?.length">
            <template #title>
                <Htag class="title text-[#FF4747]">
                    <div class="flex items-center gap-2"><span class="blocked"></span>{{ t('global.blockeds') }}</div>
                    <router-link class="see-all" :to="`/session/${sessionStore.selectedSession}?status=BLOCKED`">{{ t('global.seeAll') }} <i class="ml-2 pi pi-arrow-right"></i> </router-link>
                </Htag>
            </template>
            <template #content>
                <AvatarLine :name="nameFormat(full_name)" :time="timeFormat(started_at)" :src="photo" :key="id" class="avatar" :to="`/session/${session_id}/user/${id}`" v-for="{ full_name, photo, id, started_at, session_id } in blockedList" />
            </template>
        </Card>
        <Card class="counters-card" v-if="finishedList?.length">
            <template #title>
                <Htag class="title text-[#34C759]">
                    <div class="flex items-center gap-2"><span class="finished"></span>{{ t('global.completeds') }}</div>
                    <router-link class="see-all" :to="`/session/${sessionStore.selectedSession}?status=FINISHED`">{{ t('global.seeAll') }} <i class="ml-2 pi pi-arrow-right"></i></router-link>
                </Htag>
            </template>
            <template #content>
                <AvatarLine :name="nameFormat(full_name)" :time="timeFormat(stopped_at)" :src="photo" :key="id" class="avatar" :to="`/session/${session_id}/user/${id}`" v-for="{ full_name, photo, id, stopped_at, session_id } in finishedList" />
            </template>
        </Card>
    </aside>
</template>

<style scoped>
.progress {
    @apply w-2 h-2 block rounded-full bg-[#8A8CD9];
}

.blocked {
    @apply w-2 h-2 block rounded-full bg-[#FF4747];
}

.finished {
    @apply w-2 h-2 block rounded-full bg-[#34C759];
}

.title {
    @apply flex items-center gap-3 justify-between;
}

.avatar {
    @apply p-2;
}

.see-all {
    @apply text-sm text-gray-500 flex items-center justify-center hover:opacity-50 transition duration-300;
}

.aside {
    @apply flex flex-col gap-y-4 w-96 h-dvh border-[--border-gray] dark:bg-[--main-black] dark:border-[--border-dark];
}

.aside::-webkit-scrollbar {
    display: none;
    /* Hide scrollbar for Chrome, Safari, and Opera */
}

@media (max-width: 768px) {
    .aside {
        @apply w-full h-auto;
    }
}

@media (max-width: 1024px) {
}
</style>
